// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IOtpApi,
  IOtpApiRequest,
  IOtpApiGetAttrs,
  IOtpApiGetResponse,
  IOtpApiValidateAttrs,
  IOtpApiValidateResponse,
} from 'interfaces/back-office/otp/otp-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class OtpApi extends BaseApi<IOtpApi> implements IOtpApiRequest {
  readonly url = ApiConstant.OTP_URL
  private otpUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get otp
   *
   * @method POST
   * @access public
   *
   * @param {IOtpApiGetAttrs} payload
   *
   * @return {Promise<IOtpApiGetResponse>} Promise<IOtpApiGetResponse>
   */
  async otp_get(payload: IOtpApiGetAttrs): Promise<IOtpApiGetResponse> {
    return this.POST(`${this.otpUrl}/send`, payload.body, { ...payload.requestConfig })
  }

  /**
   * @description Validate otp
   *
   * @method POST
   * @access public
   *
   * @param {IOtpApiValidateAttrs} payload
   *
   * @return {Promise<IOtpApiValidateResponse>} Promise<IOtpApiValidateResponse>
   */
  async otp_validate(payload: IOtpApiValidateAttrs): Promise<IOtpApiValidateResponse> {
    return this.POST(`${this.otpUrl}/validate`, payload.body, { ...payload.requestConfig })
  }
}
